const keyManager = {
  templateUrl: '/modules/key-manager/key-manager.html',
  controller: 'KeyManagerController',
};

angular
  .module('key-manager.module', ['ui.router'])
  .component('keyManager', keyManager)
  .config($stateProvider => {
    $stateProvider
      .state('key-manager', {
        url: '/key-manager',
        component: 'keyManager',
        resolve: {
          auth: function (userService, $state, eventService) {
            return userService
              .resolve(['VIEW_KEY_MANAGER'])
              .then(() => { })
              .catch(() => {
                eventService.trigger('userservice:unauthorized');
                $state.go('frontpage');
              });
          },
        }
      });
  });
